export type GoogleChatAuthorization = {
  mode: "app" | "user";
  userConnectionId?: string;
  generation?: number;
};
export type GoogleChatUserConnection = {
  _id: string;
  email: string;
  status: "connected" | "reconnect_required" | "disconnected";
  lastError?: string;
  connectedBy: string;
  spaces: {
    _id: string;
    name: string;
    enabled: boolean;
    cleanupPending: boolean;
  }[];
};
export type GoogleChatUserConnections = {
  configured: boolean;
  connections: GoogleChatUserConnection[];
};
export const GOOGLE_CHAT_SETTINGS_PATH =
  "/settings/communications/google-chat/setup";
export const GOOGLE_CHAT_OAUTH_CALLBACK_PATH =
  "/settings/communications/google-chat/oauth/callback";
